// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { AccordionCode, AccordionCodeSchema } from 'api/gen/AccordionCode';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { AccordionName, AccordionNameSchema } from 'api/gen/AccordionName';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { Bookmark, BookmarkSchema } from 'api/gen/Bookmark';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PositiveInteger, PositiveIntegerSchema } from 'api/gen/PositiveInteger';

const requiredPart = t.interface({
  bookmark: BookmarkSchema,
  code: AccordionCodeSchema,
  id: PositiveIntegerSchema,
  name: AccordionNameSchema,
  position: PositiveIntegerSchema,
});

export const AccordionSchema = excess(requiredPart);

export interface Accordion extends t.TypeOf<typeof AccordionSchema> {}
